import { render, staticRenderFns } from "./MapSwipe.vue?vue&type=template&id=3afb9d0c&scoped=true&"
import script from "./MapSwipe.vue?vue&type=script&lang=js&"
export * from "./MapSwipe.vue?vue&type=script&lang=js&"
import style0 from "./MapSwipe.vue?vue&type=style&index=0&id=3afb9d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb9d0c",
  null
  
)

export default component.exports